import constants from '@playcastdotio/GlobalConfig';

export const DiscordAuthButton = () => {
  const branch = constants.VERSION.split('-')[0];
  const DISCORD_CLIENT_ID = branch === undefined || branch === 'prerelease' ? '1339926400013963345' : '1334487824275079208';

  const inviteUrl = `https://discord.com/oauth2/authorize?client_id=${DISCORD_CLIENT_ID}&permissions=536871040&response_type=code&integration_type=0&scope=bot+identify+guilds`;
  return (
    <a href={inviteUrl} className='w-full rounded-md bg-amber-400 px-4 py-2 text-center font-semibold text-gray-900 hover:bg-amber-400/60'>
      Invite Discord Bot
    </a>
  );
};
